<template>
  <div>
    <template v-if="isMobile">
      <div class="mobile-content">
        <mobile-header />
        <router-view />
        <mobile-footer />
      </div>
    </template>

    <template v-else>
      <div class="layout" :class="wrapCls">
        <page-header :showConsole="true" />

        <div class="layout-container">
          <div class="container-wrap">
            <!-- sidebar -->
            <slot v-if="$slots.sidebar" name="sidebar"></slot>
            <sidebar v-else-if="sidebarData" :title="sidebarData.title" :routes="sidebarData.routes" />
            <!-- breadcrumb -->
            <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
            <!-- main content -->
            <main-content />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeader from '@/components/page-header'
import Sidebar from './components/sidebar'
import Breadcrumb from './components/breadcrumb'
import MainContent from './components/content'
import minxinMobile from '@/mixins/mixin-mobile'
import MobileHeader from '@/components/mobile-header'
import MobileFooter from '@/components/mobile-footer'

export default {
  name: 'Layout',
  mixins: [ minxinMobile ],
  components: { PageHeader, MobileFooter, MainContent, Sidebar, Breadcrumb, MobileHeader },

  computed: {
    ...mapGetters(['sidebar']),
    sidebarData() {
      const routes = (this.$store.getters.routes || []).filter(route => !route.hidden && route.meta && route.meta.title)
      return {
        title: '产品中心',
        routes
      }
    },
    wrapCls() {
      return {
        'sidebar--hide': !(this.$slots.sidebar || this.sidebarData),
        'sidebar--close': !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
      }
    }
  },
  created() {
    console.log('Layout.created')
    console.log('routes:', this.$store.getters.routes)
    this.$store.dispatch('permission/generateRoutes')
  },
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.layout {
  @include clearfix;
  height: 100%;
  width: 100%;
  overflow: auto;
  @include scrollBar;
}
.bg_black {
  background: #212122;
}
.layout.sidebar--hide {
  .layout-container {
    position: relative;
    top: 0;
    width: 100%;
    height: 100%;
  }
}

.layout.sidebar--close {
  .sidebar-container {
    width: 58px;
  }

  .app-breadcrumb.el-breadcrumb {
    left: 78px;
  }
}

.layout .layout-container {
  position: absolute;
  left: 0;
  top: $navbarHeight;
  right: 0;
  bottom: 0;
  // background-color: #FFFFFF;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.container-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 $padding-page;
}

.mobile-content {
  @include px2rem(padding-top, $mobileNavbarH);
  width: 100%;
  overflow-x: hidden;

  /deep/ span, /deep/ p {
    line-height: 1.4 !important;
  }
  .page-content {
    @include px2rem(padding-bottom, 140px);
    margin: 0;

    /deep/ .section {
      margin: 0;
    }
    /deep/ .module_name {
      @include px2rem(margin, 60px 0);
      @include px2rem(font-size, 36px);
      @include px2rem(line-height, 50px);
      text-align: center;
      font-weight: 500;
    }
  }
}
</style>
